import React from 'react';
import { Typography } from '@mui/material';
import { Link, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

/**
 * Trust microline rendered under outbound/affiliate CTAs.
 */
const TrustMicroline = () => {
  const { t } = useTranslation();
  const { lng } = useParams();
  return (
    <Typography
      variant="caption"
      sx={{
        display: 'block',
        mt: 1.5,
        color: 'text.disabled',
        fontWeight: 400,
        lineHeight: 1.4,
        textAlign: 'center',
      }}
    >
      {t('trustMicroline.text')}{' '}
      <Typography
        component={Link}
        to={`/${lng}/como-monetizamos`}
        variant="caption"
        sx={{
          color: 'text.secondary',
          fontWeight: 500,
          textDecoration: 'underline',
          textDecorationColor: 'divider',
          '&:hover': { color: 'primary.main' },
        }}
      >
        {t('trustMicroline.moreInfo')}
      </Typography>
    </Typography>
  );
};

export default TrustMicroline;
